<template>
<v-container grid-list-md>
  <bread-crump-partial header="Softwarelösungen"></bread-crump-partial>
  <v-layout row wrap>
    <v-flex xs12 sm8 md8>
       <p>
            <strong>
                Ob individuelle Software oder angepasste Standardware,  wir bieten erfolgreiche Konzepte und effiziente Umsetzung mit modernsten Techniken.
            </strong>
        </p>
        <p>
            Für viele Unternehmen ist eine maßgeschneiderte Softwareentwicklung die beste Option. Statt mehrerer suboptimaler Lösungen und ihrer unüberschaubaren Folgekosten
            schaffen Sie so exakt die Software an, die Sie und Ihre Mitarbeiter brauchen.
        </p>
        <p>
            Um dies zu gewährleisten, arbeiten wir im Sinne der Agilen Softwareentwicklung eng mit Ihnen zusammen und entwickeln so gemeinsam die beste Lösung für Ihr Unternehmen.
            Ganz nach Ihrem Bedarf, begleiten wir Sie von der Beratung und Konzeption, über die Entwciklung, bis hin zur Installation und Support bei allen Aufgaben.
        </p>
        <p>Für ein individuelles Beratungsgespräch stehen wir Ihnen gerne zur Verfügung. <strong>Sprechen Sie uns an !</strong></p>
        <br />
        <accordion :panels="panelItems">Leistungsfelder:</accordion>
    </v-flex>
     <v-flex xs12 sm4 md4>
          <contact-widget></contact-widget>
        </v-flex>
  </v-layout>
</v-container>
</template>

<script>
import BreadCrumpPartial from './partials/BreadCrumpPartial'
import Accordion from './widgets/AccordionWidget'
import ContactWidget from './widgets/ContactWidget'

export default {
  name: 'SolutionsPage',
  components: {
    BreadCrumpPartial,
    Accordion,
    ContactWidget
  },
  data () {
    return {
      name: 'CompanyPage',
      panelItems: [{
        icon: 'local_offer',
        color: 'blue',
        title: 'Webbasierte Anwendungen',
        text: 'AngularJS, Angular, Vue, ASP.NET, PHP, HTML5, Javascript Frameworks, Apps, Websites, Services.'
      },
      {
        icon: 'local_offer',
        color: 'blue',
        title: 'Desktop Applikationen',
        text: 'C#, .NET, WinRT, SQL, NoSQL, WCF Data Services, Electron.'
      },
      {
        icon: 'local_offer',
        color: 'blue',
        title: 'Datenintegration',
        text: 'Schnittstellenprogrammierung, Datenkonvertierung, Testmanagment, Officeintegration.'
      },
      {
        icon: 'local_offer',
        color: 'green',
        title: 'Datenpräsentation',
        text: 'Reportsysteme und Prozessmanagment.'
      },
      {
        icon: 'local_offer',
        color: 'yellow accent-4',
        title: 'Datensicherheit',
        text: 'Backup, Logging, Authentifizierung, Authorisierung, Verschlüsselung.'
      }
      ]
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/SolutionsPage.vue